import React, { Component } from 'react';
import MetaDecorator from '../../services/MetaDecorator';
import teamsImage from '../../../media/images/teams.jpg';
import teamsMobileImage from '../../../media/images/teamsMobile.jpg';
import introTeams from '../../../media/images/introTeams.jpg';
import introTeamsServices from '../../../media/images/introTeamsServices.jpg';

export class Teams extends Component {
    constructor(props) {
        super(props);
        this.state = {
            width: window.innerWidth
        };
    }
    componentDidMount = () => {
        const { width } = this.state;
        const isMobile = width <= 600;
        const isTablet = width <= 992 && width > 600;

        let tabs = document.getElementsByClassName("nav-wrapper");
        if (tabs.length > 0) {
            tabs = tabs[1].querySelectorAll("ul")[0].querySelectorAll("a");
            for (let i = 0; i < tabs.length; i++) {
                tabs[i].removeAttribute('class');
                if (tabs[i].id === "scopes" || tabs[i].id === "teams") {
                    tabs[i].setAttribute('class', 'orange-text text-darken-4')
                }
            }
        }
        let mobileTabs = document.getElementsByClassName("sidenav");
        if (mobileTabs.length > 0) {
            mobileTabs = mobileTabs[0].querySelectorAll("a");
            for (let i = 0; i < mobileTabs.length; i++) {
                if (mobileTabs[i].id === "scopesMobile" || mobileTabs[i].id === "teamsMobile") {
                    mobileTabs[i].removeAttribute('class');
                    mobileTabs[i].setAttribute('class', 'orange-text text-darken-4 grey darken-3')
                }
            }
        }
        if (isMobile || isTablet) {
            let subTabs = document.getElementsByClassName("tabs");
            if (subTabs.length > 0) {
                subTabs = subTabs[0].querySelectorAll("a");
                for (let i = 0; i < subTabs.length; i++) {
                    if (subTabs[i].id === "teamsTab") {
                        subTabs[i].scrollIntoView();
                        window.scrollTo(0, 0);
                    }
                }
            }
        }

        this.updateWindowDimensions();
        window.addEventListener("resize", this.updateWindowDimensions.bind(this));
    }

    updateWindowDimensions = () => {
        this.setState({ width: window.innerWidth });
    }

    render() {
        const { width } = this.state;
        const isMobile = width <= 600;
        const isTablet = width <= 992 && width > 600;
        return (
            <React.Fragment>
                <MetaDecorator
                    title="JetMinds | Microsoft Teams Beratung, Konzeption und Entwicklung"
                    descrption="Wir sind Ihr kompetenter Ansprechpartner rund um das Thema Teams und stehen Ihnen mit solider technischer sowie funktioneller Beratung, Konzeption wowie Entwicklung zur Seite"
                    url="https://www.jetminds.de/fokusbereiche/microsoft-teams/"
                />
                 <div className="pageImageTitle">
                    {isMobile ?
                        <img className="responsive-img" style={{ width: '100%' }} src={teamsMobileImage} alt="JetMinds Microsoft Teams" loading="lazy" /> :
                        <img className="responsive-img" style={{ width: '100%' }} src={teamsImage} alt="JetMinds Microsoft Teams" loading="lazy" />}
                    {isMobile || isTablet ?
                        <div className="imgTxtMobile">
                            <h1 className={`white-text ${isTablet ? "isTablet" : "isMobile"}`}>Microsoft Teams</h1>
                        </div>
                        :
                        <div className="imgTxt">
                            <h1 className="white-text">Microsoft Teams</h1>
                        </div>}
                </div>
                <div className="container">
                    <div className="section">
                        <div className="row">
                            <div className="col s12 m12">
                                <h1 className={`${isMobile ? "pageTitleM" : "pageTitle"}`} >Das <span className="orange-text text-darken-4">leistungsstärkste</span> Tool für die Zusammenarbeit, <span className="orange-text text-darken-4">ortsunabhängig</span> kommunizieren und nahtlos im Team arbeiten</h1>
                            </div>
                        </div>

                    </div>
                </div>
                <div className="container">
                    {isMobile || isTablet ?
                        <div className="section">
                            <div className="row">
                                <div className="col s12">
                                    <p className="light">Microsoft Teams ist Ihr Hub für Teamarbeit in Microsoft 365, das als All-in-One eine breite Palette von Services wie Chat, Meetings, Callings, Videokonferenzen, Live-Events und zahlreiche Konnektoren zu Microsoft 365-Plattformen und vielen anderen Systemen und Software von Drittanbietern wie z. B. SAP, Salesforce und Google Services bietet. Teams ist auf dem Vertrauen von Microsoft konzipiert und mit einem sehr hohen Maß an Sicherheit und Compliance gesichert, was für heutige Unternehmen von entscheidender Bedeutung ist. In einem leistungsstarken digitalen Arbeitsbereich definiert Microsoft Teams in vier Kernbereiche: Kollaboration, Kommunikation, Customising und Sicherheit.</p>
                                </div>
                                <div className="col s12">
                                    <img className="responsive-img" src={introTeams} alt="JetMinds Microsoft Teams" loading="lazy" />
                                </div>
                                <div className="col s12">
                                    <p className="light">Wir sind Ihr kompetenter Ansprechpartner rund um das Thema Microsoft-Teams und stehen Ihnen mit solider technischer sowie funktioneller Beratung zur Seite. Unser umfassendes und durchdachtes End-to-End-Servicepaket für Microsoft-Teams deckt Ihre Bedürfnisse und Wünsche in Bezug auf die digitale Zusammenarbeit von der Planung bis zur Implementierung ab. Gemeinsam beginnen wir mit der Vorbereitung und evaluieren Ihre Anforderungen und begleiten Sie durch den gesamten Prozess bis zum finalen Support- und Wartungsangebot. Unser 6-Schritte End-to-End-Servicepaket gibt Ihnen einen Überblick unserer Vorgehensweise und beantwortet Ihnen erste Fragen:</p>
                                </div>
                                <div className="col s12">
                                    <img className="responsive-img" src={introTeamsServices} alt="JetMinds Microsoft Teams" loading="lazy" />
                                </div>
                            </div>
                        </div> :
                        <div className="section">
                            <div className="row">
                                <div className="col s12 m6">
                                    <img className="responsive-img" src={introTeams} alt="JetMinds Microsoft Teams" loading="lazy" />
                                </div>
                                <div className="col s12 m6">
                                    <p className="light">Microsoft Teams ist Ihr Hub für Teamarbeit in Microsoft 365, das als All-in-One eine breite Palette von Services wie Chat, Meetings, Callings, Videokonferenzen, Live-Events und zahlreiche Konnektoren zu Microsoft 365-Plattformen und vielen anderen Systemen und Software von Drittanbietern wie z. B. SAP, Salesforce und Google Services bietet. Teams ist auf dem Vertrauen von Microsoft konzipiert und mit einem sehr hohen Maß an Sicherheit und Compliance gesichert, was für heutige Unternehmen von entscheidender Bedeutung ist. In einem leistungsstarken digitalen Arbeitsbereich definiert Microsoft Teams in vier Kernbereiche: Kollaboration, Kommunikation, Customising und Sicherheit.</p>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col s12 m6">
                                    <p className="light">Wir sind Ihr kompetenter Ansprechpartner rund um das Thema Microsoft-Teams und stehen Ihnen mit solider technischer sowie funktioneller Beratung zur Seite. Unser umfassendes und durchdachtes End-to-End-Servicepaket für Microsoft-Teams deckt Ihre Bedürfnisse und Wünsche in Bezug auf die digitale Zusammenarbeit von der Planung bis zur Implementierung ab. Gemeinsam beginnen wir mit der Vorbereitung und evaluieren Ihre Anforderungen und begleiten Sie durch den gesamten Prozess bis zum finalen Support- und Wartungsangebot. Unser 6-Schritte End-to-End-Servicepaket gibt Ihnen einen Überblick unserer Vorgehensweise und beantwortet Ihnen erste Fragen:</p>
                                </div>
                                <div className="col s12 m6">
                                    <img className="responsive-img" src={introTeamsServices} alt="JetMinds Microsoft Teams" loading="lazy" />
                                </div>
                            </div>
                        </div>
                    }
                    <div className="section">
                        <div className="row">
                            <div className={`col s2 ${isTablet ? "m2" : "m1"}`}>
                                <div className="icon-block">
                                    <h2 className="center orange-text text-darken-4" style={{ marginBottom: '-25px' }}><i className="material-icons" style={{ fontSize: "35px" }}>looks_one</i></h2>
                                </div>
                            </div>
                            <div className={`col s10 ${isTablet ? "m10" : "m5"}`}>
                                <div>
                                    <br />
                                    <h5 style={{ marginTop: isMobile ? '29px' : '33px' }}>Vorbereitung</h5>
                                    <p className="light">Unabhängig davon, ob es sich um ein kleines, mittelständisches oder großes Unternehmen handelt, ist ein guter, strukturierter und vollständiger Plan für die Bereitstellung von Microsoft Teams der wichtigste und der erste Schritt zum Erfolg. In dieser unverzichtbaren Phase arbeiten wir zusammen, um Ihre Anforderungen, Ihre IT-Landschaft und den Ist-Status Ihres Unternehmens zu ermitteln um eine klare Roadmap Ihrer Ziele und die Schritte unserer Zusammenarbeit zu definieren.</p>
                                </div>
                            </div>
                            <div className={`col s2 ${isTablet ? "m2" : "m1"}`}>
                                <div className="icon-block">
                                    <h2 className="center orange-text text-darken-4" style={{ marginBottom: '-25px' }}><i className="material-icons" style={{ fontSize: "35px" }}>looks_two</i></h2>
                                </div>
                            </div>
                            <div className={`col s10 ${isTablet ? "m10" : "m5"}`}>
                                <div>
                                    <br />
                                    <h5 style={{ marginTop: isMobile ? '29px' : '33px' }}>Pilotphase</h5>
                                    <p className="light">In dieser wichtigen Phase arbeiten wir weiterhin auf der Grundlage der Vorbereitungsphase und der daraus resultierenden Ergebnisse zusammen, um die ersten geplanten und konfigurierten Teams und Channels aufzubauen. Hier konzentrieren wir uns darauf, den Change im Unternehmen zu ebnen, indem wir Early-Adopters identifizieren, die dazu beitragen können, die Adoption im gesamten Unternehmen voranzutreiben und die ersten Benutzererfahrungen zu sammeln und zu verbessern.</p>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className={`col s2 ${isTablet ? "m2" : "m1"}`}>
                                <div className="icon-block">
                                    <h2 className="center orange-text text-darken-4" style={{ marginBottom: '-25px' }}><i className="material-icons" style={{ fontSize: "35px" }}>looks_3</i></h2>
                                </div>
                            </div>
                            <div className={`col s10 ${isTablet ? "m10" : "m5"}`}>
                                <div>
                                    <br />
                                    <h5 style={{ marginTop: isMobile ? '29px' : '33px' }}>Rollout</h5>
                                    <p className="light">Nun sind wir soweit und  haben die nächste Stufe erreicht und viele wertvolle Erfahrungen aus der Pilotphase gesammelt sowie bearbeitet. Dabei haben wir unsere Teams kontinuierlich verbessert und eine genau definierte Konfiguration, Compliance und Policies, Archivierung sowie eine finale, maßgeschneiderte Vorlage für den Teams-Rollout erstellt. Jetzt können wir ohne Bedenken die Bereitstellung etablieren und vorantreiben in Form eines Self-Services oder eine von Admins getriebene Einführung.</p>
                                </div>
                            </div>
                            <div className={`col s2 ${isTablet ? "m2" : "m1"}`}>
                                <div className="icon-block">
                                    <h2 className="center orange-text text-darken-4" style={{ marginBottom: '-25px' }}><i className="material-icons" style={{ fontSize: "35px" }}>looks_4</i></h2>
                                </div>
                            </div>
                            <div className={`col s10 ${isTablet ? "m10" : "m5"}`}>
                                <div>
                                    <br />
                                    <h5 style={{ marginTop: isMobile ? '29px' : '33px' }}>Entwicklung</h5>
                                    <p className="light">Jetzt haben wir erfolgreich Teams installiert und das Fundament zur digitalen Transformation gelegt, somit kann die Kollaboration in Ihrem Unternehmen starten. Jedoch jedes Unternehmen ist einzigartig und hat eigene spezielle Anforderungen, die nicht zu 100% mit Out-of-the-Box-Funktionen einhergehen. Hier fügen wir Ihre gewünschten Funktionen hinzu und entwickeln maßgeschneiderte Add-Ins und Apps für Ihre Plattform und berücksichtigen so Ihre sämtlichen digitalen Anforderungen.</p>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className={`col s2 ${isTablet ? "m2" : "m1"}`}>
                                <div className="icon-block">
                                    <h2 className="center orange-text text-darken-4" style={{ marginBottom: '-25px' }}><i className="material-icons" style={{ fontSize: "35px" }}>looks_5</i></h2>
                                </div>
                            </div>
                            <div className={`col s10 ${isTablet ? "m10" : "m5"}`}>
                                <div>
                                    <br />
                                    <h5 style={{ marginTop: isMobile ? '29px' : '33px' }}>User-Adoption</h5>
                                    <p className="light">Jetzt verfügt Ihr Unternehmen über eine perfekte, vollständige Plattform, die alle Wünsche und Anforderungen für Ihre Kollaboration abdeckt. Jedoch aufgrund der Technologie- und Personalentwicklungen in den Abteilungen ist eine evergreen User-Adoption sehr wichtig. Wir unterstützen Ihre Mitarbeiterinnen und Mitarbeiter mit umfangreichen <a className="orange-text text-darken-4" href="/schulungen">Schulungen</a>, die nach Bedarf für Sie organisiert werden. So stellen Sie sicher, dass die Plattform richtig und mit vollem Einsatz angewendet wird.</p>
                                </div>
                            </div>
                            <div className={`col s2 ${isTablet ? "m2" : "m1"}`}>
                                <div className="icon-block">
                                    <h2 className="center orange-text text-darken-4" style={{ marginBottom: '-25px' }}><i className="material-icons" style={{ fontSize: "35px" }}>looks_6</i></h2>
                                </div>
                            </div>
                            <div className={`col s10 ${isTablet ? "m10" : "m5"}`}>
                                <div>
                                    <br />
                                    <h5 style={{ marginTop: isMobile ? '29px' : '33px' }}>Support</h5>
                                    <p className="light">Nach Vorbereitung, Pilotphase, Rollout, Entwicklung und User-Adoption sollte unsere Zusammenarbeit nicht enden. Unser umfangreiches Supportprogramm ist Ihre Sicherheit für einen entspannten Umgang mit Wartung und Problemlösungen. Durch unsere Expertise und Projekterfahrungen können wir Ihnen schnell und zuverlässig helfen und den reibungslosen Betrieb Ihrer Plattform anbieten. Somit kann Ihre IT-Abteilung sich den Tagesgeschäften zuwenden und uns die Support- und Wartungsarbeiten überlassen.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="section">
                        <div className="row center">
                            <div className="col s12 m12">
                                <a href="/kontakt" className="btn-large orange darken-4">Zur Kontaktanfrage<i className="material-icons right" style={{ fontSize: "20px" }}>arrow_forward</i></a>
                            </div>
                        </div>
                    </div>
                    {/* <div className="section">
                        <div className="row center">
                            <div className="col s12 m12">
                                <div className="video-container">
                                    <iframe title="JetMinds Microsoft Teams" width="560" height="315" src="https://www.youtube-nocookie.com/embed/SV6imUKuGQs?controls=0" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                                </div>
                            </div>
                        </div>
                    </div> */}
                </div>
            </React.Fragment>
        );
    }
}

export default Teams;


// WEBPACK FOOTER //
// ./src/components/layout/pages/Teams.js